import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { PlaceholderService
       } from 'collage-designer/stage/placeholder/placeholder.service';
import { Utils } from 'core/utils';
import { Subscription } from 'rxjs';

@Component({
    selector: 'image-rotate',
    templateUrl: './image-rotate.component.html',
    styleUrls: ['./image-rotate.component.scss'],
    standalone: false
})

export class ImageRotateComponent implements OnInit, OnDestroy
{
  public rotation: number = 0;

  private subscriptions: Subscription = new Subscription();

  constructor(
      @Inject(PlaceholderService) private placeholderService)
  {
  }

  public ngOnInit(): void
  {
    this.subscriptions.add(
        this.placeholderService.imageBeingEdited.subscribe(
            placeholder =>
                this.rotation =
                    placeholder.transformationManager.getRotation()));
  }

  public ngOnDestroy(): void
  {
    this.subscriptions.unsubscribe();
  }

  public rotate(value: number): void
  {
    this.placeholderService.getFocusedPlaceholder()
      .callWithTransformationManager(m => {
        m.rotate(value);
        this.rotation = m.getRotation();
      });
  }

  public decreaseRotateSnap(): void
  {
    let decreaseValue = this.rotation % 90;
    if (decreaseValue < 0.01) {
      decreaseValue = 90;
    }
    this.rotate(-decreaseValue);
  }

  public increaseRotateSnap(): void
  {
    let increaseValue = 90 - this.rotation % 90;
    if (increaseValue < 0.01) {
      increaseValue = 90;
    }
    this.rotate(increaseValue);
  }

  public get rangeValue(): number
  {
    let value = this.rotation;
    if (value  > 180) {
      value -= 360;
    }
    return value;
  }

  public rangeValueChanged(event: any): void
  {
    this.rotate(parseInt(event.target.value, 10) - this.rotation);
  }

  public showImageOverlay(): void
  {
    const focusedPh = this.placeholderService.getFocusedPlaceholder();
    focusedPh.showImageOverlay();
  }

  public hideImageOverlay(): void
  {
    const focusedPh = this.placeholderService.getFocusedPlaceholder();
    focusedPh.hideImageOverlay();
  }
}
